const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  page403: '/403',
  page404: '/404',
  page500: '/500',

  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    objectivesManagement: {
      root: `${ROOTS.DASHBOARD}/objectivesManagement`,
      planManagement: {
        root: `${ROOTS.DASHBOARD}/objectivesManagement/planManagement`,
        edit: `${ROOTS.DASHBOARD}/objectivesManagement/planManagement/edit`,
        new: `${ROOTS.DASHBOARD}/objectivesManagement/planManagement/new`,
        detail: `${ROOTS.DASHBOARD}/objectivesManagement/planManagement/detail`,
        businessPlanDisassemble: `${ROOTS.DASHBOARD}/objectivesManagement/planManagement/businessPlanDisassemble`,
        budgetPlanDisassemble: `${ROOTS.DASHBOARD}/objectivesManagement/planManagement/budgetPlanDisassemble`,
      },
      projectManagement: {
        root: `${ROOTS.DASHBOARD}/objectivesManagement/projectManagement`,
        edit: `${ROOTS.DASHBOARD}/objectivesManagement/projectManagement/edit`,
        new: `${ROOTS.DASHBOARD}/objectivesManagement/projectManagement/new`,
        detail: `${ROOTS.DASHBOARD}/objectivesManagement/projectManagement/detail`,
        disassemble: `${ROOTS.DASHBOARD}/objectivesManagement/projectManagement/disassemble`,
      },

      businessPlanReport: {
        root: `${ROOTS.DASHBOARD}/objectivesManagement/business-plan-report`,
        list: `${ROOTS.DASHBOARD}/objectivesManagement/business-plan-report/list`,
      },
      kpiReport: {
        root: `${ROOTS.DASHBOARD}/objectivesManagement/kpi-report`,
        list: `${ROOTS.DASHBOARD}/objectivesManagement/kpi-report/list`,
      },
    },
    systemManagement: {
      root: `${ROOTS.DASHBOARD}/systemManagement`,
      assessmentDimension: {
        root: `${ROOTS.DASHBOARD}/systemManagement/assessmentDimension`,
        new: `${ROOTS.DASHBOARD}/systemManagement/assessmentDimension/new`,
      },
      subject: {
        root: `${ROOTS.DASHBOARD}/systemManagement/subject`,
        new: `${ROOTS.DASHBOARD}/systemManagement/subject/new`,
      },
      currencyConversion: {
        root: `${ROOTS.DASHBOARD}/systemManagement/currencyConversion`,
        new: `${ROOTS.DASHBOARD}/systemManagement/currencyConversion/new`,
      },
      reportTemplate: {
        root: `${ROOTS.DASHBOARD}/systemManagement/reportTemplate`,
        new: `${ROOTS.DASHBOARD}/systemManagement/reportTemplate/new`,
        edit: `${ROOTS.DASHBOARD}/systemManagement/reportTemplate/edit`,
      },
      tradeCategory: {
        root: `${ROOTS.DASHBOARD}/systemManagement/tradeCategory`,
        new: `${ROOTS.DASHBOARD}/systemManagement/tradeCategory/new`,
      },
    },
    analysis: {
      root: `${ROOTS.DASHBOARD}/analysis`,
      statementIncomeList: `${ROOTS.DASHBOARD}/analysis/statement-income/list`,
      statementExpenseList: `${ROOTS.DASHBOARD}/analysis/statement-expense/list`,
      targetDifferenceList: `${ROOTS.DASHBOARD}/analysis/target-difference/list`,
      targetDifference: {
        root: `${ROOTS.DASHBOARD}/analysis/target-difference`,
        list: `${ROOTS.DASHBOARD}/analysis/target-difference/list`,
        detail: `${ROOTS.DASHBOARD}/analysis/target-difference/detail`,
        edit: `${ROOTS.DASHBOARD}/analysis/target-difference/edit`,
      },
      analysisReportList: `${ROOTS.DASHBOARD}/analysis/analysis-report/list`,
    },
    onlineTrading: {
      root: `${ROOTS.DASHBOARD}/onlineTrading`,
      internalTrading: {
        root: `${ROOTS.DASHBOARD}/onlineTrading/internalTrading`,
        edit: `${ROOTS.DASHBOARD}/onlineTrading/internalTrading/edit`,
        new: `${ROOTS.DASHBOARD}/onlineTrading/internalTrading/new`,
        detail: `${ROOTS.DASHBOARD}/onlineTrading/internalTrading/detail`,
        audit: `${ROOTS.DASHBOARD}/onlineTrading/internalTrading/audit`,
      },
      operationalStatementTransaction: {
        root: `${ROOTS.DASHBOARD}/onlineTrading/operationalStatementTransaction`,
        edit: (id: string) =>
          `${ROOTS.DASHBOARD}/onlineTrading/operationalStatementTransaction/${id}/edit`,
        new: `${ROOTS.DASHBOARD}/onlineTrading/operationalStatementTransaction/new`,
        details: (id: string) =>
          `${ROOTS.DASHBOARD}/onlineTrading/operationalStatementTransaction/${id}`,
      },
    },
    improvementProposal: {
      root: `${ROOTS.DASHBOARD}/improvementProposal`,
      edit: `${ROOTS.DASHBOARD}/improvementProposal/edit`,
      new: `${ROOTS.DASHBOARD}/improvementProposal/new`,
      detail: `${ROOTS.DASHBOARD}/improvementProposal/detail`,
      cooperation: {
        root: `${ROOTS.DASHBOARD}/improvementProposal/cooperation`,
      },
      actionPlanManagement: {
        root: `${ROOTS.DASHBOARD}/improvementProposal/actionPlanManagement`,
        edit: (id: string) =>
          `${ROOTS.DASHBOARD}/improvementProposal/actionPlanManagement/${id}/edit`,
        new: `${ROOTS.DASHBOARD}/improvementProposal/actionPlanManagement/new`,
        details: (id: string) =>
          `${ROOTS.DASHBOARD}/improvementProposal/actionPlanManagement/${id}`,
      },
      executionRate: {
        root: `${ROOTS.DASHBOARD}/improvementProposal/execution-rate`,
        list: `${ROOTS.DASHBOARD}/improvementProposal/execution-rate/list`,
      },
    },
  },
};
